import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Paper } from '@mui/material';
import { templates } from '../../templates';

const PreviewWrapper = styled(Paper)`
  padding: 2rem;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 100%;
  max-width: 794px; // A4 宽度
  height: auto; // 自适应高度
  overflow-y: auto;

  // 添加媒体查询以适应移动端
  @media (max-width: 768px) {
    padding: 1rem;
    max-width: 100%; // 使其在移动端占满宽度
    box-shadow: none; // 移动端去掉阴影以节省空间
  }
`;

const ResumePreview = forwardRef(({ template, data }, ref) => {
  if (!template) {
    return <div>请选择模板</div>;
  }

  const TemplateComponent = templates[template.id];

  if (!TemplateComponent) {
    return <div>模板不存在</div>;
  }

  return (
    <div >
      <PreviewWrapper ref={ref}>
        <TemplateComponent data={data} styles={template.styles} />
      </PreviewWrapper>
    </div>
  );
});

export default ResumePreview; 